<div
  class="file-drop-area"
  [ngClass]="{ 'file-over': isFileOver, 'disabled': isUploadDisabled }"
  [attr.disabled]="disabled ? true : null"
  (dragover)="disabled || onDragOver($event)"
  (dragleave)="disabled || onDragLeave($event)"
  (drop)="disabled || onDrop($event)"
>
  <img
    class="folder-icon"
    (click)="disabled || fileInput.click()" (keydown.enter)="disabled || fileInput.click()" (keydown.space)="disabled || fileInput.click()"
    src="../../../../../assets/images/folder-icon.svg"
    alt="folder icon"
  />
  <h3 class="mb-2 drag-n-drop">
    {{constants.drag_and_drop}}
    <a
      class="browse-file-link"
      (click)="disabled || fileInput.click()"
      [class.disabled-link]="disabled"
    >
    {{constants.browse}}
    </a>
  </h3>
  <input
    type="file"
    [multiple]="!allowOnlySingleFile"
    class="d-none"
    (change)="disabled || onFileSelect($event)"
    #fileInput
    [attr.disabled]="disabled ? true : null"
    accept=".pdf"
  />
</div>

<!-- Additional styles for file list and error messages (no changes needed here) -->
<ul
  class="list-group mt-3 uploaded-files-section"
  *ngIf="files?.length > 0 && fileUploadSuccess"
>
  <li *ngFor="let file of files; let i = index" class="list-group-item px-0">
    <div>
      <div class="row mx-0">
        <div
          class="col-12 col-md-9 col-sm-9 col-lg-10 d-flex align-items-center gap-2 px-0"
        >
          <div>
            <!-- Display generic file icon -->
            <img
              src="assets/images/pdf-icon.svg"
              alt="file icon"
              class="file-icon"
            />
          </div>
          <div>
            <span [title]="file.name" class="file-name">{{ file.name }}</span>
          </div>
        </div>
        <div class="col-12 col-md-3 col-sm-3 col-lg-2 view-remove">
          <!-- View span remains active -->
          <a
            class="text-link"
            (click)="viewFile(file)"
            [class.disabled-link]="false"
          >
            {{constants.view}} 
          </a>&nbsp;
          <!-- Remove a is disabled when in disabled mode -->
          <a
            class="text-link"
            (click)="disabled || removeFile($event, i)"
            [attr.disabled]="disabled ? true : null"
            [class.disabled-link]="disabled"
          >
            {{constants.remove}}
          </a>
        </div>
      </div>
    </div>
  </li>
</ul>

<div class="container cm-main-container px-0 mx-0 mt-2">
  <div class="alert revision-alert" role="alert" *ngIf="!disabled && fileSizeErrorMessage">
    <div class="container">
      <div class="row">
        <div class="my-2">
          {{ fileSizeErrorMessage }}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container cm-main-container px-0 mx-0 mt-2">
  <div class="alert revision-alert" role="alert" *ngIf="!disabled && multipleFilesErrorMessage">
    <div class="container">
      <div class="row">
        <div class="my-2">
          {{ multipleFilesErrorMessage }}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container cm-main-container px-0 mx-0 mt-2">
  <div class="alert revision-alert" role="alert" *ngIf="!disabled && fileNameErrorMessage">
    <div class="container">
      <div class="row">
        <div class="my-2">
          {{ fileNameErrorMessage }}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container cm-main-container px-0 mx-0 mt-2">
  <div class="alert revision-alert" role="alert"*ngIf="!disabled && pdfFileErrorMessage">
    <div class="container">
      <div class="row">
        <div class="my-2">
          {{ pdfFileErrorMessage }}
        </div>
      </div>
    </div>
  </div>
</div>
